// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O6k8","clinicsSelect":"styles_clinicsSelect__1kAT5"};